import Home from './Home.data-manager-edit-os-version.vue'

export default {
  Home
}